document.querySelectorAll('.post-card-media[data-image]').forEach((card) => {
  const image = card.dataset.image;

  if (image) {
    card.style.setProperty('--post-card-image', `url("${image.replace(/"/g, '\\"')}")`);
  }
});
